module.exports = __webpack_public_path__ + "img/a4.da2d9f2d.jpg";